import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=069b7d2f&"
import script from "./ProjectBoard.vue?vue&type=script&lang=js&"
export * from "./ProjectBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports